import { AppImages } from "../utility/AppImages";

const CURRENT_ENVIRONMENT = "production"; // Options: 'production' or 'staging'

const ENVIRONMENTS = {
  production: {
    apiUrl:
      "https://6nj9hwvxpj.execute-api.eu-west-2.amazonaws.com/dev-user-management/",
    chatWebSocket:
      "wss://i6o0579mpb.execute-api.eu-west-2.amazonaws.com/production/",
    liveStreamWebSocket:
      "wss://lr1b9dha37.execute-api.eu-west-2.amazonaws.com/production/",
    notificationWebSocket:
      "wss://k1lascwiyf.execute-api.eu-west-2.amazonaws.com/production/",
    eventSocketUrl: "https://socket.kallout.com", // TODO: Update with production URL
  },
  staging: {
    apiUrl: "https://6nj9hwvxpj.execute-api.eu-west-2.amazonaws.com/staging/",
    chatWebSocket:
      "wss://i6o0579mpb.execute-api.eu-west-2.amazonaws.com/staging/",
    liveStreamWebSocket:
      "wss://lr1b9dha37.execute-api.eu-west-2.amazonaws.com/staging/",
    notificationWebSocket:
      "wss://k1lascwiyf.execute-api.eu-west-2.amazonaws.com/staging/",
    eventSocketUrl: "https://socket.kallout.io", // Development - NestJS socket service
  },
};

// Get current environment config
export const currentEnv = ENVIRONMENTS[CURRENT_ENVIRONMENT];

// Legacy support - keep existing code working
export const urls = {
  v1: currentEnv.apiUrl,
};

export const getWebUrl = () => {
  if (typeof window !== "undefined") {
    const hostname = window.location.hostname;

    if (hostname === "localhost" || hostname.includes("127.0.0.1")) {
      return "http://localhost:19006";
    } else if (hostname.includes("testing.d246i6gj3tz2g1.amplifyapp.com")) {
      return "https://testing.d246i6gj3tz2g1.amplifyapp.com";
    } else if (hostname.includes("main.d246i6gj3tz2g1.amplifyapp.com")) {
      return "https://platform.kallout.io";
    } else if (hostname.includes("platform.kallout.io")) {
      return "https://platform.kallout.io";
    } else if (hostname.includes("develop.d246i6gj3tz2g1.amplifyapp.com")) {
      return "https://develop.d246i6gj3tz2g1.amplifyapp.com";
    }

    return window.location.origin;
  }

  if (urls.v1.includes("staging")) {
    return "https://testing.d246i6gj3tz2g1.amplifyapp.com";
  }

  return "https://platform.kallout.io";
};

const getStreamingToolsUrl = () => {
  return "https://main.d1vdysgdy8z4tu.amplifyapp.com";
};

export const webUrl = "https://superior-run.com";
export const dynamicWebUrl = getWebUrl();
export const dynamicBlitzUrl =
  CURRENT_ENVIRONMENT === "staging"
    ? "https://blitz-staging.kallout.io"
    : "https://blitz.kallout.io";
export const streamingToolsUrl = getStreamingToolsUrl();
export const base_url = urls.v1;
export const domain = urls.domain;

export const endpoints = {
  auth: {
    login: "user/login",
    register: "user/register",
    resetPassword: "user/reset-password",
    resetPasswordConfirm: "user/reset-password/confirm",
    userVerify: "user/verify",
    userProfile: "user/profile",
    createStripeAccount: "user/createStripeCustomer",
    redeemBalance: "user/redeemBalance",
    otherUserProfile: "user/otheruser",
    logout: "user/logout",
    balance: "user/balance",
    updateProfile: "user/update-profile",
    uploadToS3: "uploadToS3",
    updateGenre: "user/updateGenre",
    getGenreGames: "user/getGenre",
    getLiveNowGames: "event/live?query=nokia&limit=8",
    resendVerificationCode: "user/resend-code",
    changePassword: "user/changePassword",
    blockUser: "user/blockuser",
    youtube: "user/youtube",
    twitch: "user/twitch",
    getObsConnection: "user/obs/config",
    storeObsConnection: "user/obs/create",
    updateObsConnection: "/user/obs/config",
    getReferral: "user/referral",
    checkRole: "/user/role",
    claimDailyCheckInReward: "user/dailyCheckIn",
  },
  avatar: {
    avatar: "avatar",
  },
  events: {
    getEventForNotLoginUser: "/stream/event",
    searchEvent: "search",
    allRanking: "allRanking",
    ranking: "ranking",
    buyTicket: "event/buyTicket",
    eventsPopular: "events/popular",
    eventsRecommended: "events/recommended",
    eventsUpcoming: "events/upcoming",
    eventsDetails: "event?ID=",
    updateEvent: "event",
    userEvents: "user/events",
    searchUsers: "event/searchUsers",
    suggestions: "event/getSugesstions",
    createEvent: "event/create",
    sendChallenge: "event/sendChallenge",
    challengeAlertList: "event/challenges",
    getAllNotifications: "event/getNotification",
    getNotificationFromEvent: "event/getNotificationFromEvent",
    deleteNotification: "event/deleteNotification",
    getWatchingNotifications: "watchingEvent",
    challengeDetails: "event/getChallenge?ID=",
    challengeRespond: "event/responseToChallenge",
    negotiateTerms: "event/negotiateTerms",
    IvechallengeAlertList: "event/sentChallenges",
    platform: "event/platform",
    autoLive: "event/autolive",
    ChallengeUserNotificationHandler: "event/send",
    signUpEvent: "event/signUpEvent",
    ticketEvent: "event/getTicketEvent",
    submitResult: "event/logResults",
    watchingEvent: "/watchingEvent",
    checkIn: "event/checkIn",
    confirmAttentDance: "event/attendance",
    twitchUrlKey: "user/twitch",
    youTubeUrlKey: "user/youtube",
    updateStreamStatusOnStartAndStopRecording: "event/update",
    updateAudienceOnStreamPaused: "event/paused",
    logPublicVote: "event/vote",
    publicVoteEnable: "event/update/vote",
    getUserUpcomingEvents: "user/upcomingEvents",
    getUserWatchingEvents: "user/getUserWatchingEvents",
    cancelEvent: "event/cancel",
    getShortUrlData: "user/referral/track",
  },
  product: {
    // getProducts: "/product/user/products?",
  },
  profile: {
    getActiveSubscription: "user/getActiveSubscription",
    userBalance: "user/balance",
    beltConvert: "user/beltConvert",
    paymentBeltExchange: "payment/beltExchange",
    paymentCreateSession: "payment/createSession",
    subscription: "payment/createSubscription",
    updateSubscription: "payment/updateSubscription",
    paymentRequestSell: "payment/request/sell",
    paymentRequestRefund: "payment/request/refund",
    paymentRequestConvert: "payment/request/convert",
    paymentTokensToBelts: "payment/tokensToBelts",
    paymentSuccess: "payment/success",
    processPayment: "payment/success",
    transaction: "transaction",
  },
  disputes: {
    disputesGetAll: "disputes/getAll",
    disputesSend: "disputes/send",
    adminDisputeGetAll: "disputes/admin/getAllDisputes",
    adminDisputeGetSpecific: "disputes/admin/getSpecificDispute",
    adminWinner: "disputes/admin/adminWinner",
    adminPublicVoteResult: "disputes/admin/publicVoteResult",
    generateDispute: "event/generateDispute",
  },
  chat: {
    chatCreate: "chat/create",
    getAllChats: "chat/getAllChats",
    chatGetHistory: "chat/getHistory",
  },
  Chat: {
    createChat: "chat/createChat",
    fetchChatHistory: "chat/history",
    fetchUserChatList: "chat/list",
    fetchUserStatus: "chat/status",
    addMember: "chat/add",
    deleteChat: "chat/delete",
  },
  notification: {
    getUserNotification: "user/notification",
    addNotification: "user/notification/add",
    updateNotification: "user/notification/update",
    getNotificationById: "user/notification/Id",
    getEventNotification: "user/notification/event",
    markNotificationAsRead: "user/notification/read-status",
    markNotificationAsSeen: "user/notification/mark-seen",
    UnSeenNotificationCount: "user/notification/counts",
    InviteChallengeNotification: "event/invite",
    AcceptEventUpdates: "user/update",
  },
  tickets: {
    ticketsSoldOverview: "tickets/soldOverview",
  },
  help: {
    createTicket: "help-tickets/create",
    getAllHelpTickets: "help-tickets/getHelpTickets",
    updateHelpTickets: "help-tickets/updateHelpTicket",
  },
  stream: {
    createStream: "stream/youtube",
    storeToken: "store/youtube",
    userConnectionStatus: "stream/status",
    streamDetailsYoutube: "stream/youtube/details",
    userDisconnect: "store/disconnect",
    userDetails: "stream/event/profile ",
    UpdateYouTubeEmbeddingSettings: "stream/update",
    handleStreamParticipationReward: "/user/coins/stream",
  },
  streamOrganizer: {
    streamChats: "stream/event/chats",
    streamDetails: "stream/event/detail",
    streamGifts: "stream/event/gifts",
    streamLikes: "stream/event/like",
  },
  streamParticipant: {
    streamChats: "stream/event/chats",
    streamDetails: "stream/event/detail",
    streamGifts: "stream/event/gifts",
    streamLikes: "stream/event/like",
  },
  streamTwitch: {
    createStream: "stream/twitchcreate",
    storeToken: "store/twitch",
    goLiveAndUpdateStream: "stream/getTwitchStreams",
    updateStreamOnStopStream: "stream/twitch/update",
    userConnectionStatus: "stream/status",
    streamDetailsYoutube: "stream/youtube/details",
    userDisconnect: "store/disconnect",
    userDetails: "stream/event/profile ",
  },
  pastEvent: {
    fetchPastEvent: "event/past",
    fetchUserPastEvent: "user/pastevents",
    fetchPastEventById: "event/pastevent",
  },
  activity: {
    storeActivity: "activity",
    getActivities: "activity",
    liveUsers: "activity/live-users",
  },
};

export const genres = [
  { id: 1, title: "Action", isSelected: 0 },
  { id: 2, title: "Adventure", isSelected: 0 },
  { id: 3, title: "Shooter", isSelected: 0 },
  { id: 4, title: "RPG", isSelected: 0 },
  { id: 5, title: "Battle Royale", isSelected: 0 },
  { id: 6, title: "Sports", isSelected: 0 },
  { id: 7, title: "Racing", isSelected: 0 },
  { id: 8, title: "Simulation", isSelected: 0 },
  { id: 9, title: "Puzzle", isSelected: 0 },
  { id: 10, title: "Horror", isSelected: 0 },
  { id: 11, title: "Indie", isSelected: 0 },
  { id: 12, title: "Snooker", isSelected: 0 },
  { id: 13, title: "Darts", isSelected: 0 },
];

export const NotificationType = {
  EMAIL_PRIVATE_MESSAGE: "emailPrivateMessage",
  EMAIL_BATTLE_NOTIFICATION: "emailBattleNotification",
  OCCASIONAL_EMAIL: "occasionalEmail",
  READ_ON_CHALLENGE: "readOnChallenge",
};

export const BeltImages = {
  Bronze: AppImages.icBronzeBelt,
  Silver: AppImages.icSilverBelt,
  Gold: AppImages.icGoldBelt,
  Platinum: AppImages.icPlatinumBelt,
  Coin: AppImages.icCoinBelt,
};

export function generateBeltSubstitutions(stakeTypes, stakeAmounts) {
  const typesArray = stakeTypes.split(",").map((type) => type.trim());
  const amountsArray = stakeAmounts.split(",").map((amount) => amount.trim());

  const belts = typesArray.map((type, index) => ({
    beltImage: BeltImages[type] || BeltImages["Bronze"],
    beltName: type,
    beltQuantity: amountsArray[index] || "0",
  }));

  return {
    Belt1Image: belts[0]?.beltImage || "",
    Belt1Name: belts[0]?.beltName || "",
    Belt1Quantity: belts[0]?.beltQuantity || "",

    Belt2Image: belts[1]?.beltImage || "",
    Belt2Name: belts[1]?.beltName || "",
    Belt2Quantity: belts[1]?.beltQuantity || "",

    Belt3Image: belts[2]?.beltImage || "",
    Belt3Name: belts[2]?.beltName || "",
    Belt3Quantity: belts[2]?.beltQuantity || "",

    Belt4Image: belts[3]?.beltImage || "",
    Belt4Name: belts[3]?.beltName || "",
    Belt4Quantity: belts[3]?.beltQuantity || "",

    Belt5Image: belts[4]?.beltImage || "",
    Belt5Name: belts[4]?.beltName || "",
    Belt5Quantity: belts[4]?.beltQuantity || "",
  };
}

export const countryWithTimezone = [
  {
    country: "Ivory Coast",
    timezone: "(+00:00) Abidjan",
  },
  {
    country: "Ghana",
    timezone: "(+00:00) Accra",
  },
  {
    country: "Ethiopia",
    timezone: "(+03:00) Addis Ababa",
  },
  {
    country: "Algeria",
    timezone: "(+01:00) Algiers",
  },
  {
    country: "Eritrea",
    timezone: "(+03:00) Asmara",
  },
  {
    country: "Mali",
    timezone: "(+00:00) Bamako",
  },
  {
    country: "Central African Republic",
    timezone: "(+01:00) Bangui",
  },
  {
    country: "Gambia",
    timezone: "(+00:00) Banjul",
  },
  {
    country: "Guinea-Bissau",
    timezone: "(+00:00) Bissau",
  },
  {
    country: "Malawi",
    timezone: "(+02:00) Blantyre",
  },
  {
    country: "Republic of the Congo",
    timezone: "(+01:00) Brazzaville",
  },
  {
    country: "Burundi",
    timezone: "(+02:00) Bujumbura",
  },
  {
    country: "Egypt",
    timezone: "(+03:00) Cairo",
  },
  {
    country: "Morocco",
    timezone: "(+01:00) Casablanca",
  },
  {
    country: "Guinea",
    timezone: "(+00:00) Conakry",
  },
  {
    country: "Senegal",
    timezone: "(+00:00) Dakar",
  },
  {
    country: "Tanzania",
    timezone: "(+03:00) Dar es_Salaam",
  },
  {
    country: "Djibouti",
    timezone: "(+03:00) Djibouti",
  },
  {
    country: "Cameroon",
    timezone: "(+01:00) Douala",
  },
  {
    country: "Sierra Leone",
    timezone: "(+00:00) Freetown",
  },
  {
    country: "Botswana",
    timezone: "(+02:00) Gaborone",
  },
  {
    country: "Zimbabwe",
    timezone: "(+02:00) Harare",
  },
  {
    country: "South Africa",
    timezone: "(+02:00) Johannesburg",
  },
  {
    country: "South Sudan",
    timezone: "(+02:00) Juba",
  },
  {
    country: "Uganda",
    timezone: "(+03:00) Kampala",
  },
  {
    country: "Sudan",
    timezone: "(+02:00) Khartoum",
  },
  {
    country: "Rwanda",
    timezone: "(+02:00) Kigali",
  },
  {
    country: "Nigeria",
    timezone: "(+01:00) Lagos",
  },
  {
    country: "Gabon",
    timezone: "(+01:00) Libreville",
  },
  {
    country: "Togo",
    timezone: "(+00:00) Lome",
  },
  {
    country: "Angola",
    timezone: "(+01:00) Luanda",
  },
  {
    country: "Democratic Republic of the Congo",
    timezone: "(+02:00) Lubumbashi",
  },
  {
    country: "Zambia",
    timezone: "(+02:00) Lusaka",
  },
  {
    country: "Equatorial Guinea",
    timezone: "(+01:00) Malabo",
  },
  {
    country: "Mozambique",
    timezone: "(+02:00) Maputo",
  },
  {
    country: "Lesotho",
    timezone: "(+02:00) Maseru",
  },
  {
    country: "Eswatini",
    timezone: "(+02:00) Mbabane",
  },
  {
    country: "Somalia",
    timezone: "(+03:00) Mogadishu",
  },
  {
    country: "Liberia",
    timezone: "(+00:00) Monrovia",
  },
  {
    country: "Kenya",
    timezone: "(+03:00) Nairobi",
  },
  {
    country: "Chad",
    timezone: "(+01:00) Ndjamena",
  },
  {
    country: "Niger",
    timezone: "(+01:00) Niamey",
  },
  {
    country: "Mauritania",
    timezone: "(+00:00) Nouakchott",
  },
  {
    country: "Burkina Faso",
    timezone: "(+00:00) Ouagadougou",
  },
  {
    country: "Benin",
    timezone: "(+01:00) Porto-Novo",
  },
  {
    country: "Sao Tome and Principe",
    timezone: "(+00:00) Sao Tome",
  },
  {
    country: "Libya",
    timezone: "(+02:00) Tripoli",
  },
  {
    country: "Tunisia",
    timezone: "(+01:00) Tunis",
  },
  {
    country: "Namibia",
    timezone: "(+02:00) Windhoek",
  },
  {
    country: "Anguilla",
    timezone: "(-04:00) Anguilla",
  },
  {
    country: "Antigua and Barbuda",
    timezone: "(-04:00) Antigua",
  },
  {
    country: "Argentina",
    timezone: "(-03:00) Buenos Aires",
  },
  {
    country: "Aruba",
    timezone: "(-04:00) Aruba",
  },
  {
    country: "Paraguay",
    timezone: "(-04:00) Asuncion",
  },
  {
    country: "Barbados",
    timezone: "(-04:00) Barbados",
  },
  {
    country: "Brazil",
    timezone: "(-03:00) Belem",
  },
  {
    country: "Belize",
    timezone: "(-06:00) Belize",
  },
  {
    country: "Colombia",
    timezone: "(-05:00) Bogota",
  },
  {
    country: "Venezuela",
    timezone: "(-04:00) Caracas",
  },
  {
    country: "French Guiana",
    timezone: "(-03:00) Cayenne",
  },
  {
    country: "Cayman Islands",
    timezone: "(-05:00) Cayman",
  },
  {
    country: "United States",
    timezone: "(-05:00) Chicago",
  },
  {
    country: "Costa Rica",
    timezone: "(-06:00) Costa Rica",
  },
  {
    country: "Curacao",
    timezone: "(-04:00) Curacao",
  },
  {
    country: "Dominica",
    timezone: "(-04:00) Dominica",
  },
  {
    country: "El Salvador",
    timezone: "(-06:00) El Salvador",
  },
  {
    country: "Turks and Caicos Islands",
    timezone: "(-04:00) Grand Turk",
  },
  {
    country: "Grenada",
    timezone: "(-04:00) Grenada",
  },
  {
    country: "Guadeloupe",
    timezone: "(-04:00) Guadeloupe",
  },
  {
    country: "Guatemala",
    timezone: "(-06:00) Guatemala",
  },
  {
    country: "Ecuador",
    timezone: "(-05:00) Guayaquil",
  },
  {
    country: "Guyana",
    timezone: "(-04:00) Guyana",
  },
  {
    country: "Cuba",
    timezone: "(-04:00) Havana",
  },
  {
    country: "Jamaica",
    timezone: "(-05:00) Jamaica",
  },
  {
    country: "Bonaire, Saint Eustatius and Saba",
    timezone: "(-04:00) Kralendijk",
  },
  {
    country: "Bolivia",
    timezone: "(-04:00) La Paz",
  },
  {
    country: "Peru",
    timezone: "(-05:00) Lima",
  },
  {
    country: "Sint Maarten",
    timezone: "(-04:00) Lower Princes",
  },

  {
    country: "Nicaragua",
    timezone: "(-06:00) Managua",
  },

  {
    country: "Saint Martin",
    timezone: "(-04:00) Marigot",
  },
  {
    country: "Martinique",
    timezone: "(-04:00) Martinique",
  },
  {
    country: "Mexico",
    timezone: "(-06:00) Mexico City",
  },
  {
    country: "Saint Pierre and Miquelon",
    timezone: "(-02:00) Miquelon",
  },
  {
    country: "Uruguay",
    timezone: "(-03:00) Montevideo",
  },
  {
    country: "Montserrat",
    timezone: "(-04:00) Montserrat",
  },
  {
    country: "Bahamas",
    timezone: "(-04:00) Nassau",
  },

  {
    country: "Greenland",
    timezone: "(-01:00) Nuuk",
  },
  {
    country: "Panama",
    timezone: "(-05:00) Panama",
  },
  {
    country: "Suriname",
    timezone: "(-03:00) Paramaribo",
  },

  {
    country: "Haiti",
    timezone: "(-04:00) Port-au-Prince",
  },
  {
    country: "Trinidad and Tobago",
    timezone: "(-04:00) Port of_Spain",
  },

  {
    country: "Puerto Rico",
    timezone: "(-04:00) Puerto Rico",
  },
  {
    country: "Chile",
    timezone: "(-03:00) Santiago",
  },
  {
    country: "Dominican Republic",
    timezone: "(-04:00) Santo Domingo",
  },
  {
    country: "Saint Barthelemy",
    timezone: "(-04:00) St Barthelemy",
  },
  {
    country: "Saint Kitts and Nevis",
    timezone: "(-04:00) St Kitts",
  },
  {
    country: "Saint Lucia",
    timezone: "(-04:00) St Lucia",
  },
  {
    country: "U.S. Virgin Islands",
    timezone: "(-04:00) St Thomas",
  },
  {
    country: "Saint Vincent and the Grenadines",
    timezone: "(-04:00) St Vincent",
  },
  {
    country: "Honduras",
    timezone: "(-06:00) Tegucigalpa",
  },
  {
    country: "Canada",
    timezone: "(-04:00) Toronto",
  },
  {
    country: "British Virgin Islands",
    timezone: "(-04:00) Tortola",
  },
  {
    country: "Antarctica",
    timezone: "(+12:00) McMurdo",
  },
  {
    country: "Svalbard and Jan Mayen",
    timezone: "(+02:00) Longyearbyen",
  },
  {
    country: "Yemen",
    timezone: "(+03:00) Aden",
  },
  {
    country: "Jordan",
    timezone: "(+03:00) Amman",
  },
  {
    country: "Kazakhstan",
    timezone: "(+05:00) Aqtau",
  },
  {
    country: "Turkmenistan",
    timezone: "(+05:00) Ashgabat",
  },
  {
    country: "Iraq",
    timezone: "(+03:00) Baghdad",
  },
  {
    country: "Bahrain",
    timezone: "(+03:00) Bahrain",
  },
  {
    country: "Azerbaijan",
    timezone: "(+04:00) Baku",
  },
  {
    country: "Thailand",
    timezone: "(+07:00) Bangkok",
  },
  {
    country: "Lebanon",
    timezone: "(+03:00) Beirut",
  },
  {
    country: "Kyrgyzstan",
    timezone: "(+06:00) Bishkek",
  },
  {
    country: "Brunei",
    timezone: "(+08:00) Brunei",
  },
  {
    country: "Sri Lanka",
    timezone: "(+05:30) Colombo",
  },
  {
    country: "Syria",
    timezone: "(+03:00) Damascus",
  },
  {
    country: "Bangladesh",
    timezone: "(+06:00) Dhaka",
  },
  {
    country: "Timor Leste",
    timezone: "(+09:00) Dili",
  },
  {
    country: "United Arab Emirates",
    timezone: "(+04:00) Dubai",
  },
  {
    country: "Tajikistan",
    timezone: "(+05:00) Dushanbe",
  },
  {
    country: "Palestinian Territory",
    timezone: "(+03:00) Gaza",
  },
  {
    country: "Vietnam",
    timezone: "(+07:00) Ho Chi_Minh",
  },
  {
    country: "Hong Kong",
    timezone: "(+08:00) Hong Kong",
  },
  {
    country: "Indonesia",
    timezone: "(+07:00) Jakarta",
  },
  {
    country: "Israel",
    timezone: "(+03:00) Jerusalem",
  },
  {
    country: "Afghanistan",
    timezone: "(+04:30) Kabul",
  },
  {
    country: "Pakistan",
    timezone: "(+05:00) Karachi",
  },
  {
    country: "Nepal",
    timezone: "(+05:45) Kathmandu",
  },
  {
    country: "India",
    timezone: "(+05:30) Kolkata",
  },
  {
    country: "Malaysia",
    timezone: "(+08:00) Kuching",
  },
  {
    country: "Kuwait",
    timezone: "(+03:00) Kuwait",
  },
  {
    country: "Macao",
    timezone: "(+08:00) Macau",
  },
  {
    country: "Philippines",
    timezone: "(+08:00) Manila",
  },
  {
    country: "Oman",
    timezone: "(+04:00) Muscat",
  },
  {
    country: "Cyprus",
    timezone: "(+03:00) Nicosia",
  },
  {
    country: "Cambodia",
    timezone: "(+07:00) Phnom Penh",
  },
  {
    country: "North Korea",
    timezone: "(+09:00) Pyongyang",
  },
  {
    country: "Qatar",
    timezone: "(+03:00) Qatar",
  },
  {
    country: "Saudi Arabia",
    timezone: "(+03:00) Riyadh",
  },
  {
    country: "Uzbekistan",
    timezone: "(+05:00) Samarkand",
  },
  {
    country: "South Korea",
    timezone: "(+09:00) Seoul",
  },
  {
    country: "China",
    timezone: "(+08:00) Shanghai",
  },
  {
    country: "Singapore",
    timezone: "(+08:00) Singapore",
  },
  {
    country: "Taiwan",
    timezone: "(+08:00) Taipei",
  },
  {
    country: "Georgia",
    timezone: "(+04:00) Tbilisi",
  },
  {
    country: "Iran",
    timezone: "(+03:30) Tehran",
  },
  {
    country: "Bhutan",
    timezone: "(+06:00) Thimphu",
  },
  {
    country: "Japan",
    timezone: "(+09:00) Tokyo",
  },
  {
    country: "Mongolia",
    timezone: "(+08:00) Ulaanbaatar",
  },
  {
    country: "Laos",
    timezone: "(+07:00) Vientiane",
  },
  {
    country: "Myanmar",
    timezone: "(+06:30) Yangon",
  },
  {
    country: "Armenia",
    timezone: "(+04:00) Yerevan",
  },
  {
    country: "Bermuda",
    timezone: "(-03:00) Bermuda",
  },
  {
    country: "Cabo Verde",
    timezone: "(-01:00) Cape Verde",
  },
  {
    country: "Faroe Islands",
    timezone: "(+01:00) Faroe",
  },
  {
    country: "Iceland",
    timezone: "(+00:00) Reykjavik",
  },
  {
    country: "South Georgia and the South Sandwich Islands",
    timezone: "(-02:00) South Georgia",
  },
  {
    country: "Saint Helena",
    timezone: "(+00:00) St Helena",
  },
  {
    country: "Falkland Islands",
    timezone: "(-03:00) Stanley",
  },
  {
    country: "Australia",
    timezone: "(+10:00) Melbourne",
  },

  {
    country: "Netherlands",
    timezone: "(+02:00) Amsterdam",
  },
  {
    country: "Andorra",
    timezone: "(+02:00) Andorra",
  },
  {
    country: "Greece",
    timezone: "(+03:00) Athens",
  },
  {
    country: "Serbia",
    timezone: "(+02:00) Belgrade",
  },
  {
    country: "Germany",
    timezone: "(+02:00) Berlin",
  },
  {
    country: "Slovakia",
    timezone: "(+02:00) Bratislava",
  },
  {
    country: "Belgium",
    timezone: "(+02:00) Brussels",
  },
  {
    country: "Romania",
    timezone: "(+03:00) Bucharest",
  },
  {
    country: "Hungary",
    timezone: "(+02:00) Budapest",
  },
  {
    country: "Moldova",
    timezone: "(+03:00) Chisinau",
  },
  {
    country: "Denmark",
    timezone: "(+02:00) Copenhagen",
  },
  {
    country: "Ireland",
    timezone: "(+01:00) Dublin",
  },
  {
    country: "Gibraltar",
    timezone: "(+02:00) Gibraltar",
  },
  {
    country: "Guernsey",
    timezone: "(+01:00) Guernsey",
  },
  {
    country: "Finland",
    timezone: "(+03:00) Helsinki",
  },
  {
    country: "Isle of Man",
    timezone: "(+01:00) Isle of_Man",
  },
  {
    country: "Turkey",
    timezone: "(+03:00) Istanbul",
  },
  {
    country: "Jersey",
    timezone: "(+01:00) Jersey",
  },
  {
    country: "Ukraine",
    timezone: "(+03:00) Kyiv",
  },
  {
    country: "Portugal",
    timezone: "(+01:00) Lisbon",
  },
  {
    country: "Slovenia",
    timezone: "(+02:00) Ljubljana",
  },
  {
    country: "United Kingdom",
    timezone: "(+01:00) London",
  },
  {
    country: "Luxembourg",
    timezone: "(+02:00) Luxembourg",
  },
  {
    country: "Spain",
    timezone: "(+02:00) Madrid",
  },
  {
    country: "Malta",
    timezone: "(+02:00) Malta",
  },
  {
    country: "Aland Islands",
    timezone: "(+03:00) Mariehamn",
  },
  {
    country: "Belarus",
    timezone: "(+03:00) Minsk",
  },
  {
    country: "Monaco",
    timezone: "(+02:00) Monaco",
  },
  {
    country: "Russia",
    timezone: "(+03:00) Moscow",
  },
  {
    country: "Norway",
    timezone: "(+02:00) Oslo",
  },
  {
    country: "France",
    timezone: "(+02:00) Paris",
  },
  {
    country: "Montenegro",
    timezone: "(+02:00) Podgorica",
  },
  {
    country: "Czechia",
    timezone: "(+02:00) Prague",
  },
  {
    country: "Latvia",
    timezone: "(+03:00) Riga",
  },
  {
    country: "Italy",
    timezone: "(+02:00) Rome",
  },
  {
    country: "San Marino",
    timezone: "(+02:00) San Marino",
  },
  {
    country: "Bosnia and Herzegovina",
    timezone: "(+02:00) Sarajevo",
  },
  {
    country: "North Macedonia",
    timezone: "(+02:00) Skopje",
  },
  {
    country: "Bulgaria",
    timezone: "(+03:00) Sofia",
  },
  {
    country: "Sweden",
    timezone: "(+02:00) Stockholm",
  },
  {
    country: "Estonia",
    timezone: "(+03:00) Tallinn",
  },
  {
    country: "Albania",
    timezone: "(+02:00) Tirane",
  },
  {
    country: "Liechtenstein",
    timezone: "(+02:00) Vaduz",
  },
  {
    country: "Vatican",
    timezone: "(+02:00) Vatican",
  },
  {
    country: "Austria",
    timezone: "(+02:00) Vienna",
  },
  {
    country: "Lithuania",
    timezone: "(+03:00) Vilnius",
  },
  {
    country: "Poland",
    timezone: "(+02:00) Warsaw",
  },
  {
    country: "Croatia",
    timezone: "(+02:00) Zagreb",
  },
  {
    country: "Switzerland",
    timezone: "(+02:00) Zurich",
  },
  {
    country: "Madagascar",
    timezone: "(+03:00) Antananarivo",
  },
  {
    country: "British Indian Ocean Territory",
    timezone: "(+06:00) Chagos",
  },
  {
    country: "Christmas Island",
    timezone: "(+07:00) Christmas",
  },
  {
    country: "Cocos Islands",
    timezone: "(+06:30) Cocos",
  },
  {
    country: "Comoros",
    timezone: "(+03:00) Comoro",
  },
  {
    country: "French Southern Territories",
    timezone: "(+05:00) Kerguelen",
  },
  {
    country: "Seychelles",
    timezone: "(+04:00) Mahe",
  },
  {
    country: "Maldives",
    timezone: "(+05:00) Maldives",
  },
  {
    country: "Mauritius",
    timezone: "(+04:00) Mauritius",
  },
  {
    country: "Mayotte",
    timezone: "(+03:00) Mayotte",
  },
  {
    country: "Reunion",
    timezone: "(+04:00) Reunion",
  },
  {
    country: "Samoa",
    timezone: "(+13:00) Apia",
  },
  {
    country: "New Zealand",
    timezone: "(+12:45) Chatham",
  },
  {
    country: "Vanuatu",
    timezone: "(+11:00) Efate",
  },
  {
    country: "Tokelau",
    timezone: "(+13:00) Fakaofo",
  },
  {
    country: "Fiji",
    timezone: "(+12:00) Fiji",
  },
  {
    country: "Tuvalu",
    timezone: "(+12:00) Funafuti",
  },
  {
    country: "Solomon Islands",
    timezone: "(+11:00) Guadalcanal",
  },
  {
    country: "Guam",
    timezone: "(+10:00) Guam",
  },
  {
    country: "Kiribati",
    timezone: "(+14:00) Kiritimati",
  },
  {
    country: "Marshall Islands",
    timezone: "(+12:00) Majuro",
  },
  {
    country: "United States Minor Outlying Islands",
    timezone: "(-11:00) Midway",
  },
  {
    country: "Nauru",
    timezone: "(+12:00) Nauru",
  },
  {
    country: "Niue",
    timezone: "(-11:00) Niue",
  },
  {
    country: "Norfolk Island",
    timezone: "(+11:00) Norfolk",
  },
  {
    country: "New Caledonia",
    timezone: "(+11:00) Noumea",
  },
  {
    country: "American Samoa",
    timezone: "(-11:00) Pago Pago",
  },
  {
    country: "Palau",
    timezone: "(+09:00) Palau",
  },
  {
    country: "Pitcairn",
    timezone: "(-08:00) Pitcairn",
  },
  {
    country: "Micronesia",
    timezone: "(+11:00) Pohnpei",
  },
  {
    country: "Papua New Guinea",
    timezone: "(+10:00) Port Moresby",
  },
  {
    country: "Cook Islands",
    timezone: "(-10:00) Rarotonga",
  },
  {
    country: "Northern Mariana Islands",
    timezone: "(+10:00) Saipan",
  },
  {
    country: "French Polynesia",
    timezone: "(-10:00) Tahiti",
  },
  {
    country: "Tonga",
    timezone: "(+13:00) Tongatapu",
  },
  {
    country: "Wallis and Futuna",
    timezone: "(+12:00) Wallis",
  },
];

export const giftData = [
  {
    id: 1,
    image: AppImages.icWhiteDollarIcon,
    gift: AppImages.keepItUp,
    giftName: "Keep it up",
    price: 20,
  },
  {
    id: 2,
    image: AppImages.icWhiteDollarIcon,
    gift: AppImages.highFive,
    giftName: "High five",
    price: 50,
  },
  {
    id: 3,
    image: AppImages.icWhiteDollarIcon,
    gift: AppImages.rose,
    giftName: "Rose",
    price: 75,
  },
  {
    id: 4,
    image: AppImages.icWhiteDollarIcon,
    gift: AppImages.awesome,
    giftName: "Awesome",
    price: 110,
  },
  {
    id: 5,
    image: AppImages.icWhiteDollarIcon,
    gift: AppImages.respect,
    giftName: "Respect",
    price: 200,
  },
  {
    id: 6,
    image: AppImages.icWhiteDollarIcon,
    gift: AppImages.wowPow,
    giftName: "wow pow",
    price: 350,
  },
  {
    id: 7,
    image: AppImages.icWhiteDollarIcon,
    gift: AppImages.magic,
    giftName: "Magic",
    price: 500,
  },
  {
    id: 9,
    image: AppImages.icWhiteDollarIcon,
    gift: AppImages.coolDude,
    giftName: "Cool dude",
    price: 700,
  },
  {
    id: 10,
    image: AppImages.icWhiteDollarIcon,
    gift: AppImages.unicorn,
    giftName: "Unicorn",
    price: 1000,
  },
  {
    id: 11,
    image: AppImages.icWhiteDollarIcon,
    gift: AppImages.realShooter,
    giftName: "Real shooter",
    price: 1600,
  },
  {
    id: 12,
    image: AppImages.icWhiteDollarIcon,
    gift: AppImages.goldenBoots,
    giftName: "Golden boots",
    price: 2000,
  },
  {
    id: 13,
    image: AppImages.icWhiteDollarIcon,
    gift: AppImages.gladiator,
    giftName: "Gladiator",
    price: 2500,
  },
  {
    id: 14,
    image: AppImages.icWhiteDollarIcon,
    gift: AppImages.ninja,
    giftName: "Ninja",
    price: 3500,
  },
  {
    id: 15,
    image: AppImages.icWhiteDollarIcon,
    gift: AppImages.shadow,
    giftName: "Shadow",
    price: 4000,
  },
  {
    id: 16,
    image: AppImages.icWhiteDollarIcon,
    gift: AppImages.moneyPouch,
    giftName: "Money pouch",
    price: 5000,
  },
  {
    id: 17,
    image: AppImages.icWhiteDollarIcon,
    gift: AppImages.crowned,
    giftName: "Crowned",
    price: 10000,
  },
];
